/**
 * Validates the `data-default-view` script attribute and resolves it to a
 * `WidgetView`. Falls back to the default surface when the attribute is
 * missing or unrecognised so the widget always lands in a usable state.
 * Matching is lenient — surrounding whitespace is trimmed and casing is
 * ignored, so `Card`, ` PREVIEW `, `Pill` all parse.
 */

import { warnLog } from "../config";
import { WidgetView } from "../types";
import { defaultWidgetSurface } from "./constants";

const validViews = new Set<string>(Object.values(WidgetView));

export function parseDefaultView(raw: string | undefined): WidgetView {
  if (raw === undefined) return defaultWidgetSurface;

  const normalised = raw.trim().toLowerCase();
  if (validViews.has(normalised)) return normalised as WidgetView;

  warnLog(
    `Invalid data-default-view "${raw}". ` +
      `Expected one of ${Object.values(WidgetView).join(", ")}. ` +
      `Falling back to "${defaultWidgetSurface}".`,
  );
  return defaultWidgetSurface;
}
